module.exports = __webpack_public_path__ + "img/small.9e522106.jpg";